import { render, staticRenderFns } from "./FinanceDashboard.vue?vue&type=template&id=2db400cd&scoped=true&"
import script from "./FinanceDashboard.vue?vue&type=script&lang=js&"
export * from "./FinanceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDashboard.vue?vue&type=style&index=0&id=2db400cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db400cd",
  null
  
)

export default component.exports